export default "__VITE_ASSET__DKQVfPTg__"